import { withIcon } from "@icons/_withIcon";

// Changelog: name was CaretDownUncontained
export const TriangleDownFill = withIcon(
  () => <path d="M5.60504 5.5L0 0H11.2101L5.60504 5.5Z" />,
  {
    viewBox: "0 0 11 6",
  }
);
